export function emptyScript() {
    return { statements: [], partial: false };
}
